/*
  Routes for whole Roster 
*/

import React from 'react';
import LOCALIZATION from 'services/LocalizationService';

// Application URLs
import URL from "constants/ApplicationUrls";

/* Routes */
const TaskCenter = React.lazy(() => import('components/TaskCenter/Admin'))

const NewmanTanks = React.lazy(() => import('components/singleProjectDetail'))

const Personnel = React.lazy(() => import('components/Personnel/List'))

const Flights = React.lazy(() => import('components/Flights/List'))

const Accomodation = React.lazy(() => import('components/Accomodation/List'))

// Change Requests
const MyChangeRequests = React.lazy(() => import('components/ChangeRequests/MyRequests'))


const ROUTES = [

  // Change Requests (for Task-Only users) - First route for Operations Team
  { path: URL.MY_CHANGE_REQUESTS, exact: true, component: MyChangeRequests, name: 'My Change Requests' },

  // Tash Center
  { path: URL.TASK_CENTER, exact: true, component: TaskCenter, name: LOCALIZATION.TASK_CENTRE },


  // Single Project Detail
  { path: URL.PROJECT_DETAIL, exact: true, component: NewmanTanks },

  // Personnel
  { path: URL.PERSONNEL_LIST, exact: true, component: Personnel, name: LOCALIZATION.PERSONNEL },

  // Flights
  { path: URL.FLIGHTS_LIST, exact: true, component: Flights, name: LOCALIZATION.FLIGHTS },

  // Accomodation
  { path: URL.ACCOMODATION_LIST, exact: true, component: Accomodation, name: LOCALIZATION.ACCOMODATION },

];

export default ROUTES;